import { ACCOUNT_ACTIONS } from './account.interfaces';

export const AccountActionTypes: ACCOUNT_ACTIONS =  {
  ACCOUNT_LOGIN_START: '[account] ACCOUNT_LOGIN_START',
  ACCOUNT_LOGIN_SUCCESS: '[account] ACCOUNT_LOGIN_SUCCESS',
  ACCOUNT_LOGIN_FAILURE: '[account] ACCOUNT_LOGIN_FAILURE',

  ACCOUNT_LOGOUT_START: '[account] ACCOUNT_LOGOUT_START',
  ACCOUNT_LOGOUT_SUCCESS: '[account] ACCOUNT_LOGOUT_SUCCESS',
  ACCOUNT_LOGOUT_FAILURE: '[account] ACCOUNT_LOGOUT_FAILURE',

  ACCOUNT_LOGIN_CHECK_START: '[account] ACCOUNT_LOGIN_CHECK_START',
  ACCOUNT_LOGIN_CHECK_SUCCESS: '[account] ACCOUNT_LOGIN_CHECK_SUCCESS',
  ACCOUNT_LOGIN_CHECK_FAILURE: '[account] ACCOUNT_LOGIN_CHECK_FAILURE',

  ACCOUNT_FORGOT_PASSWORD_START: '[account] ACCOUNT_FORGOT_PASSWORD_START',
  ACCOUNT_FORGOT_PASSWORD_SUCCESS: '[account] ACCOUNT_FORGOT_PASSWORD_SUCCESS',
  ACCOUNT_FORGOT_PASSWORD_FAILURE: '[account] ACCOUNT_FORGOT_PASSWORD_FAILURE',

  ACCOUNT_LOGOUT_SILENTLY_START: '[account] ACCOUNT_LOGOUT_SILENTLY_START',
  ACCOUNT_LOGOUT_SILENTLY_SUCCESS: '[account] ACCOUNT_LOGOUT_SILENTLY_SUCCESS',
  ACCOUNT_LOGOUT_SILENTLY_FAILURE: '[account] ACCOUNT_LOGOUT_SILENTLY_FAILURE'

};

export const COOKIE = 'NQT2022';
export const NO_COOKIE_MSG = 'No login cookie found';

export const LOGIN_RESPONSE = 'LoginResponse';